__webpack_require__.p = "https://erambeau-famous-chess-games.netlify.app/";